module.exports = __webpack_public_path__ + "static/img/SNX3.55138d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SNX3.jpg
// module id = 710
// module chunks = 1